import { render } from "./PayBack.vue?vue&type=template&id=57824a84&scoped=true"
import script from "./PayBack.vue?vue&type=script&lang=js"
export * from "./PayBack.vue?vue&type=script&lang=js"

import "./PayBack.vue?vue&type=style&index=0&id=57824a84&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57824a84"]])

export default __exports__